<app-breadcrumb></app-breadcrumb>
<div class="container">
     <div class="main-container-chart">
          <label class="ch-title">Flight Time by Year</label>
          <div class="chart" *ngIf="chartResponseData$ | async as chartResponseData">
               <!-- @if (chartResponseData.data.length > 0){ -->
                    <p-chart 
                    type="bar" 
                    [data]="chartData" 
                    [options]="options"
                    width="100%"
                    height="350px"
                    />
               <!-- } -->
          </div>
          <div class="ch-footer">Tap on a bar to see the flight time for that year.</div>
          <div class="card">
               <div class="column">
                    <div class="row">
                         <div>Total All Years</div>
                         <div>{{yearsTotal | number: '1.1-1'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Highest Year</div>
                         <div>{{yearHighest | number: '1.1-1'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Average</div>
                         <div>{{yearAverage | number: '1.1-1'}} hrs/year</div>
                    </div>

               </div>
          </div>
     </div>
</div>
